import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from "../Api/ViewPostedInvoice";
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
const { ToWords } = require("to-words");

const InvoiceBody = ({ invoiceData }) => {
  const getCurrencyConfig = (code) => {
  switch (code) {
    case "USD":
      return { locale: "en-US", currency: "USD", name: "DOLLARS" };
    case "EUR":
      return { locale: "de-DE", currency: "EUR", name: "EUROS" };
    case "GBP":
      return { locale: "en-GB", currency: "GBP", name: "POUNDS" };
    case "INR":
    default:
      return { locale: "en-IN", currency: "INR", name: "RUPEES" };
  }
};
const currencyCode = invoiceData?.invoice?.currencyCode || "INR";

const currencyConfig = getCurrencyConfig(currencyCode);

const toWords = new ToWords({
  localeCode: currencyConfig.locale,
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
  },
});
  const componentRef = useRef();
  const location = useLocation();

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Invoice",
  });

  const invoiceId = location.pathname.split("/")[2];
  const [count, setCount] = useState("");

  // Safe conversion function for numbers
  const safeToFixed = (value, decimals = 2) => {
    if (value === null || value === undefined || isNaN(value)) {
      return "0.00";
    }
    return parseFloat(value).toFixed(decimals);
  };

  // Safe number conversion
  const safeNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return 0;
    }
    return parseFloat(value);
  };
const formatCurrency = (value) => {
  return new Intl.NumberFormat(currencyConfig.locale, {
    style: "currency",
    currency: currencyCode,
  }).format(safeNumber(value));
};
  const totalGSTWords = toWords
    .convert(
      safeNumber(invoiceData?.invoiceSummary?.totalCGST) +
        safeNumber(invoiceData?.invoiceSummary?.totalSGST) +
        safeNumber(invoiceData?.invoiceSummary?.totalIGST),
      { currency: true }
    )
    .toUpperCase();

  console.log(invoiceData, "invoiceData");

  return (
    <div>
      {/* <!-- Products Table --> */}
      <table className="products-table">
        <thead>
          <tr>
            <th>SR. NO.</th>
            <th>PRODUCT DESCRIPTION</th>
            {invoiceData?.invoice?.currencyCode==="INR" &&<th>HSN/SAC CODE</th>}
            <th>Batch Number</th>
            <th>MRP</th>
            <th>Expiry Date</th>
            <th>QUANTITY</th>
            <th>UOM</th>
            <th>BILLING RATE</th>
            <th>BASIC VALUE</th>
            <th>DISC %</th>
            <th>DISCOUNT VALUE</th>
            <th>TAXABLE VALUE</th>
           {invoiceData?.invoice?.currencyCode==="INR" && <th colspan="2">IGST</th>}
            {invoiceData?.invoice?.currencyCode==="INR" &&<th colspan="2">CGST</th>}
            {invoiceData?.invoice?.currencyCode==="INR" &&<th colspan="2">SGST</th>}
            <th>Gross Value</th>
          </tr>
          {invoiceData?.invoice?.currencyCode==="INR" &&<tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th>RATE%</th>
            <th>AMOUNT</th>
            <th></th>
          </tr>}
        </thead>
        <tbody>
          {invoiceData?.items?.length > 0 &&
            invoiceData?.items.map((data, index) => {
              const price = safeNumber(data?.invoiceItem?.price);
              const quantity = safeNumber(data?.invoiceItem?.quantity);
              const basicValue = price * quantity;

              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{data?.itemName || "-"}</td>
                  {invoiceData?.invoice?.currencyCode==="INR" &&<td>{data?.invoiceItem?.hsn || "-"}</td>}
                  <td>{data?.invoiceItem?.batchId || "-"}</td>
                  <td>{formatCurrency(data?.batchLabel?.mrpInclGst)}</td>
                  <td>
                    {data?.expiryDate
                      ?.split("T")[0]
                      .split("-")
                      .reverse()
                      .join("-") || "-"}
                  </td>
                  <td>{data?.invoiceItem?.quantity || "0"}</td>
                  <td>{data?.invoiceItem?.unitCode || "-"}</td>
                  <td>{formatCurrency(data?.invoiceItem?.price)}</td>
                  <td>{formatCurrency(basicValue)}</td>
                  <td>{safeToFixed(data?.invoiceItem?.discPercent)}</td>
                  <td>{formatCurrency(data?.invoiceItem?.discountValue)}</td>
                  <td>{formatCurrency(data?.invoiceItem?.taxableValue)}</td>
                  {invoiceData?.invoice?.currencyCode==="INR" &&<td>{data?.invoiceItem?.igst || "0"}</td>}
                  {invoiceData?.invoice?.currencyCode==="INR" &&<td>{formatCurrency(data?.invoiceItem?.igstAmount)}</td>}
                 {invoiceData?.invoice?.currencyCode==="INR" && <td>{data?.invoiceItem?.cgst || "0"}</td>}
                  {invoiceData?.invoice?.currencyCode==="INR" &&<td>{formatCurrency(data?.invoiceItem?.cgstAmount)}</td>}
                  {invoiceData?.invoice?.currencyCode==="INR" && <td>{data?.invoiceItem?.sgst || "0"}</td>}
                  {invoiceData?.invoice?.currencyCode==="INR" && <td>{formatCurrency(data?.invoiceItem?.sgstAmount)}</td>}
                  <td>{formatCurrency(data?.invoiceItem?.grossValue)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {/* <!-- HSN Summary --> */}
      {invoiceData?.invoice?.currencyCode==="INR" &&<div className="hsn-summary">
        <table className="hsn-table">
          <thead>
            <tr>
              <th>HSN WISE SUMMARY</th>
              <th>HSN CODE</th>
              <th>TAXABLE VALUE</th>
              <th>IGST RATE %</th>
              <th>IGST AMOUNT</th>
              <th>CGST RATE %</th>
              <th>CGST AMOUNT</th>
              <th>SGST/UT RATE %</th>
              <th>SGST/UT AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData?.groupedItems?.length > 0 &&
              invoiceData?.groupedItems.map((data, index) => {
                return (
                  <tr key={index}>
                    <td></td>
                    <td>{data?.hsnCode || "-"}</td>
                    <td>{formatCurrency(data?.totalTaxableValue)}</td>
                    <td>{data?.igstRate || "0"}</td>
                    <td>{formatCurrency(data?.totalIGST)}</td>
                    <td>{data?.cgstRate || "0"}</td>
                    <td>{formatCurrency(data?.totalCGST)}</td>
                    <td>{data?.sgstRate || "0"}</td>
                    <td>{formatCurrency(data?.totalSGST)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>}

      {/* <!-- Bottom Section --> */}
      <div className="bottom-section">
        <div className="payment-terms">
          <div className="total-words">
            <div>
             {invoiceData?.invoice?.currencyCode==="INR" && <strong>TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords}</strong>}
            </div>
            <br />
            <div>
             <strong>
  TOTAL NET PAYABLE (IN WORDS) :{" "}
  {toWords
    .convert(
      Math.round(
        safeNumber(invoiceData?.invoiceSummary?.totalamount)
      )
    )
    .toUpperCase()}{" "}
  {currencyConfig.name} ONLY
</strong>
            </div>
          </div>
          <div>
            <h6>
              Notes:<p>{invoiceData?.invoice?.subj_desc || "-"}</p>
            </h6>
          </div>
        </div>

        <div className="amount-summary">
          {invoiceData?.invoice?.currencyCode==="INR" && <div className="amount-row">
            <div className="amount-label">TAXABLE AMOUNT</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.totalTaxableAmount)}
            </div>
          </div>}
            {invoiceData?.invoice?.currencyCode==="INR" && <div className="amount-row">
          <div className="amount-label">CGST AMOUNT</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.totalCGST)}
            </div>
          </div>}
          {invoiceData?.invoice?.currencyCode==="INR" &&<div className="amount-row">
             <div className="amount-label">SGST/UT AMOUNT</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.totalSGST)}
            </div>
          </div>}
           { invoiceData?.invoice?.currencyCode==="INR" &&<div className="amount-row">
           <div className="amount-label">IGST AMOUNT</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.totalIGST)}
            </div>
          </div>}
          <div className="amount-row">
            <div className="amount-label">TOTAL AMOUNT</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.totalamount)}
            </div>
          </div>
          <div className="amount-row">
            <div className="amount-label">Rounding off</div>
            <div className="amount-value">
              {formatCurrency(invoiceData?.invoiceSummary?.roundOffValue)}
            </div>
          </div>
          <div className="amount-row" style={{ background: "#f0f0f0" }}>
            <div className="amount-label">NET PAYABLE AMOUNT</div>
            <div className="amount-value" style={{ fontWeight: "bold" }}>
              {formatCurrency(invoiceData?.invoiceSummary?.totalamount)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceBody;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../Styling/Invoice.css";
// import { getInvoiceData } from "../Api/ViewPostedInvoice";
// import { Base_URL } from "../url";
// import { useReactToPrint } from "react-to-print";
// const { ToWords } = require("to-words");
// const toWords = new ToWords({
//   localeCode: "en-IN", // Indian format
//   converterOptions: {
//     currency: true,
//     ignoreDecimal: false,
//     ignoreZeroCurrency: false,
//     doNotAddOnly: false,
//   },
// });
// const InvoiceBody = ({ invoiceData }) => {
//   const componentRef = useRef();
//   const toWords = new ToWords();
//   const location = useLocation();
//   const handlePrint = useReactToPrint({
//     contentRef: componentRef, // ✅ new API for v3+
//     documentTitle: "Invoice",
//   });

//   const invoiceId = location.pathname.split("/")[2];

//   console.log(invoiceId, "invoiceId");
//   // const [invoiceData, setInvoiceData] = useState({});
//   const [count, setCount] = useState("");
//   // useEffect(() => {
//   //   const fetchInvoiceData = async () => {
//   //     const res = await getInvoiceData(invoiceId);
//   //     console.log(res, 'res dngjf jhjkdt hjkt');
//   //     setInvoiceData(res)
//   //     setCount(res?.items?.length)
//   //   }
//   //   fetchInvoiceData()
//   // }, [])
//   const totalGSTWords = toWords
//     .convert(
//       Number(invoiceData?.invoiceSummary?.totalCGST || 0) +
//         Number(invoiceData?.invoiceSummary?.totalSGST || 0) +
//         Number(invoiceData?.invoiceSummary?.totalIGST || 0),
//       { currency: true }
//     )
//     .toUpperCase();
//   console.log(invoiceData, "invoiceData");

//   return (
//     <div>
//       {/* <!-- Products Table --> */}
//       <table className="products-table">
//         <thead>
//           <tr>
//             <th>SR. NO.</th>
//             <th>PRODUCT DESCRIPTION</th>
//             <th>HSN/SAC CODE</th>
//             <th>Batch Number</th>
//             <th>MRP</th>
//             {/* <th>Batch Qty.</th>
//                 <th>MRP</th> */}
//             <th>Expiry Date</th>
//             <th>QUANTITY</th>
//             <th>UOM</th>
//             <th>BILLING RATE</th>
//             <th>BASIC VALUE</th>
//             <th>DISC %</th>
//             <th>DISCOUNT VALUE</th>
//             <th>TAXABLE VALUE</th>
//             <th colspan="2">IGST</th>
//             <th colspan="2">CGST</th>
//             <th colspan="2">SGST</th>
//             <th>Gross Value</th>
//           </tr>
//           <tr>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             {/* <th></th>
//                 <th></th> */}
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th></th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th>RATE%</th>
//             <th>AMOUNT</th>
//             <th></th>
//           </tr>
//         </thead>
//         <tbody>
//           {invoiceData?.items?.length > 0 &&
//             invoiceData?.items.map((data, index) => {
//               return (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{data?.itemName}</td>
//                   <td>{data?.invoiceItem?.hsn}</td>
//                   <td>{data?.invoiceItem?.batchId}</td>
//                   <td>{data?.batchLabel?.mrpInclGst.toFixed(2) || 0}</td>
//                   {/* <td>NULL</td>
//                     <td>NULL</td> */}
//                   <td>
//                     {data?.expiryDate
//                       ?.split("T")[0]
//                       .split("-")
//                       .reverse()
//                       .join("-")}
//                   </td>
//                   <td>{data?.invoiceItem?.quantity}</td>
//                   <td>{data?.invoiceItem?.unitCode}</td>
//                   <td>₹{data?.invoiceItem?.price}</td>
//                   <td>
//                     {`₹${
//                       parseFloat(data?.invoiceItem?.price || 0) *
//                       parseFloat(data?.invoiceItem?.quantity || 0)
//                     }`}
//                   </td>
//                   <td>{data?.invoiceItem?.discPercent.toFixed(2) || 0}</td>
//                   <td>₹{data?.invoiceItem?.discountValue.toFixed(2) || 0}</td>
//                   <td>₹{data?.invoiceItem?.taxableValue.toFixed(2) || 0}</td>
//                   {/* <td>{`₹${(parseFloat(data?.invoiceItem?.price || 0) *
//                      parseFloat(data?.invoiceItem?.quantity || 0)).toFixed(2) - parseFloat(data?.invoiceItem?.discountValue)}`}</td> */}

//                   <td>{data?.invoiceItem?.igst}</td>
//                   <td>
//                     ₹{parseFloat(data?.invoiceItem?.igstAmount.toFixed(2)) || 0}
//                   </td>
//                   <td>{data?.invoiceItem?.cgst}</td>
//                   <td>{data?.invoiceItem?.cgstAmount.toFixed(2) || 0}</td>
//                   <td>{data?.invoiceItem?.sgst}</td>
//                   <td>
//                     ₹{parseFloat(data?.invoiceItem?.sgstAmount.toFixed(2)) || 0}
//                   </td>

//                   <td>₹{data?.invoiceItem?.grossValue.toFixed(2) || 0}</td>
//                 </tr>
//               );
//             })}
//         </tbody>
//       </table>

//       {/* <!-- HSN Summary --> */}
//       <div className="hsn-summary">
//         <table className="hsn-table">
//           <thead>
//             <tr>
//               <th>HSN WISE SUMMARY</th>
//               <th>HSN CODE</th>
//               <th>TAXABLE VALUE</th>
//               <th>IGST RATE %</th>
//               <th>IGST AMOUNT</th>
//               <th>CGST RATE %</th>
//               <th>CGST AMOUNT</th>
//               <th>SGST/UT RATE %</th>
//               <th>SGST/UT AMOUNT</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoiceData?.groupedItems?.length > 0 &&
//               invoiceData?.groupedItems.map((data, index) => {
//                 return (
//                   <tr key={index}>
//                     <td></td>
//                     <td>{data?.hsnCode}</td>
//                     <td>{data?.totalTaxableValue.toFixed(2) || 0}</td>
//                     <td>{data?.igstRate}</td>
//                     <td>{data?.totalIGST.toFixed(2) || 0}</td>
//                     <td>{data?.cgstRate}</td>
//                     <td>{data?.totalCGST.toFixed(2) || 0}</td>
//                     <td>{data?.sgstRate}</td>
//                     <td>{data?.totalSGST.toFixed(2) || 0}</td>
//                   </tr>
//                 );
//               })}
//           </tbody>
//         </table>
//       </div>

//       {/* <!-- Bottom Section --> */}
//       <div className="bottom-section">
//         <div className="payment-terms">
//           {/* <div style={{ marginBottom: "10px" }}><strong>IRN NO. :</strong></div> */}

//           <div className="total-words">
//             <div>
//               <strong>
//                 TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords}
//                 {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount)} */}
//                 {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount);} */}
//               </strong>
//             </div>
//             <br />
//             <div>
//               <strong>
//                 TOTAL NET PAYABLE (IN WORDS) :{" "}
//                 {toWords
//                   .convert(
//                     Math.round(
//                       Number(invoiceData?.invoiceSummary?.totalamount ?? 0)
//                     )
//                   )
//                   .toUpperCase()}{" "}
//                 RUPEES AND ZERO PAISE ONLY
//               </strong>
//             </div>
//           </div>
//           <div>
//             <h6>
//               Notes:<p>{invoiceData?.invoice?.subj_desc}</p>
//             </h6>
//           </div>
//         </div>

//         <div className="amount-summary">
//           <div className="amount-row">
//             <div className="amount-label">TAXABLE AMOUNT</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.totalTaxableAmount}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">CGST AMOUNT</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.totalCGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">SGST/UT AMOUNT</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.totalSGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">IGST AMOUNT</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.totalIGST.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">TOTAL AMOUNT</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.totalamount.toFixed(2) || 0}
//             </div>
//           </div>
//           <div className="amount-row">
//             <div className="amount-label">Rounding off</div>
//             <div className="amount-value">
//               {invoiceData?.invoiceSummary?.roundOffValue}
//             </div>
//           </div>
//           <div className="amount-row" style={{ background: "#f0f0f0" }}>
//             <div className="amount-label">NET PAYABLE AMOUNT</div>
//             <div className="amount-value" style={{ fontWeight: "bold" }}>
//               {invoiceData?.invoiceSummary?.totalamount.toFixed(2) ?? 0}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* terms conetent start */}
//     </div>
//   );
// };
// export default InvoiceBody;
